import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const OverviewIcon = ({
  title = 'Overview',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 30 24" {...props}>
    {/* prettier-ignore */}
    <g fill="none" fillRule="nonzero"><path d="M0 0h30v30H0z"/><g fill="currentColor"><path d="M3 17a2 2 0 110-4 2 2 0 010 4zm0-1.5a.5.5 0 100-1 .5.5 0 000 1zM9 17a2 2 0 110-4 2 2 0 010 4zm0-1.5a.5.5 0 100-1 .5.5 0 000 1zM15 17a2 2 0 110-4 2 2 0 010 4zm0-1.5a.5.5 0 100-1 .5.5 0 000 1zM21 17a2 2 0 110-4 2 2 0 010 4zm0-1.5a.5.5 0 100-1 .5.5 0 000 1zM9 23a2 2 0 110-4 2 2 0 010 4zm0-1.5a.5.5 0 100-1 .5.5 0 000 1zM15 23a2 2 0 110-4 2 2 0 010 4zm0-1.5a.5.5 0 100-1 .5.5 0 000 1zM21 23a2 2 0 110-4 2 2 0 010 4zm0-1.5a.5.5 0 100-1 .5.5 0 000 1zM27 17a2 2 0 110-4 2 2 0 010 4zm0-1.5a.5.5 0 100-1 .5.5 0 000 1z"/></g><rect width="12.5" height="7.5" x=".75" y=".75" stroke="currentColor" strokeWidth="1.5" rx="2"/><rect width="12.5" height="7.5" x="16.75" y=".75" stroke="currentColor" strokeWidth="1.5" rx="2"/></g>
  </CreateIconComponent>
);

export default OverviewIcon;
